export default __webpack_public_path__ + "static/media/Ardent Atlantean Relic.71bc5490.jpg";